var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconCloseComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-close").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { d: "M7.05711 8.00004L3.43088 4.37381C3.30071 4.24364 3.30071 4.03258 3.43088 3.90241L3.90229 3.43101C4.03246 3.30083 4.24352 3.30083 4.37369 3.43101L7.99992 7.05723L11.6261 3.43101C11.7563 3.30083 11.9674 3.30083 12.0976 3.43101L12.569 3.90241C12.6991 4.03258 12.6991 4.24364 12.569 4.37381L8.94273 8.00004L12.569 11.6263C12.6991 11.7564 12.6991 11.9675 12.569 12.0977L12.0976 12.5691C11.9674 12.6993 11.7563 12.6993 11.6261 12.5691L7.99992 8.94285L4.37369 12.5691C4.24352 12.6993 4.03246 12.6993 3.90229 12.5691L3.43088 12.0977C3.30071 11.9675 3.30071 11.7564 3.43088 11.6263L7.05711 8.00004Z", fillOpacity: "1" }));
}
var IconClose = React.forwardRef(IconCloseComponent);
export default IconClose;
